import Button from '@rio-cloud/rio-uikit/Button';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import Divider from '@rio-cloud/rio-uikit/Divider';
import { FormattedMessage } from 'react-intl';

interface PastDepartureBlockDialogProps {
    show: boolean;
    onClose: () => void;
}

export const PastDepartureBlockDialog = ({ show, onClose }: PastDepartureBlockDialogProps) => (
    <Dialog
        show={show}
        bsSize={Dialog.SIZE_XS}
        title={<FormattedMessage id='intl-msg:smartRoute.tour.pastDepartureBlock.title' />}
        body={
            <>
                <Divider spacing={0} />
                <div className='padding-y-10'>
                    <FormattedMessage id='intl-msg:smartRoute.tour.pastDepartureBlock.message' />
                </div>
                <Divider dividerColor='lighter' spacing={0} />
            </>
        }
        footer={
            <div className='display-flex justify-content-end'>
                <Button bsStyle='primary' onClick={onClose}>
                    <FormattedMessage id='intl-msg:smartRoute.generic.close' />
                </Button>
            </div>
        }
    />
);
